import {Platform} from "react-native";

export const currentPlatform = {
    isWeb: () => Platform.OS === 'web',
}
